import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter, Route, Switch } from 'react-router-dom';
import LogRocket from 'logrocket';

import * as ROUTES from '../../constants/routes';
import UnguardedRoute from '../UnguardedRoute';
import ProtectedRoute from '../ProtectedRoute';
import SignUpOTPVerifyForm from './otpVerify';
import SignUpPage, { SignUpLink } from './signUp';
import GuardianOnBoardBasicForm from './guardianOnBoardBasic';
import OnBoardBasicForm from './onBoardBasic';
import GuardianOTPVerifyForm from './otpVerifyGuardian';
import OnBoardBasicFirebaseForm from './onBoardBasicFirebase';
import GuardianSignUpForm from './guardianSignup';
import PendingInvites from '../Invites/pending';
import BranchingFormAdd from './branchingAdd';
import BranchingFormUpdate from './branchingUpdate';

LogRocket.init('oa4wxt/global-talent');

const SignUp = (props) => {
  return (
    <Switch>
      <UnguardedRoute
        exact
        path={ROUTES.SIGN_UP}
        component={() => <SignUpPage {...props} />}
      />
      <Route
        exact
        path={ROUTES.SIGN_UP_OTP}
        component={() => <SignUpOTPVerifyForm {...props} />}
      />
      <ProtectedRoute
        exact
        path={ROUTES.SIGN_UP_GUARDIAN}
        component={() => <GuardianSignUpForm {...props} />}
      />
      <ProtectedRoute
        exact
        path={ROUTES.SIGN_UP_OTP_GUARDIAN}
        component={() => <GuardianOTPVerifyForm {...props} />}
      />
      <ProtectedRoute
        exact
        path={ROUTES.SIGN_UP_ONBOARD_LANDING_GUARDIAN}
        component={() => <GuardianOnBoardBasicForm {...props} />}
      />
      <ProtectedRoute
        exact
        path={ROUTES.SIGN_UP_ONBOARD_LANDING}
        component={() => <OnBoardBasicForm {...props} />}
      />
      <ProtectedRoute
        exact
        path={ROUTES.SIGN_UP_ONBOARD_LANDING_FIREBASE}
        component={() => <OnBoardBasicFirebaseForm {...props} />}
      />
      <ProtectedRoute
        exact
        path={ROUTES.SIGN_UP_INVITES}
        component={() => <PendingInvites {...props} />}
      />
      <ProtectedRoute
        exact
        path={ROUTES.SIGN_UP_ONBOARD_BRANCH}
        component={() => <BranchingFormAdd {...props} />}
      />
      <ProtectedRoute
        exact
        path={ROUTES.SIGN_UP_ONBOARD_BRANCH_UPDATE}
        component={() => <BranchingFormUpdate {...props} />}
      />
    </Switch>
  );
};

const mapStateToProps = (state) => ({
  info: state.user.info,
  email: state.register.email,
});

const mapDispatchToProps = {};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SignUp));

export { SignUpLink };
